import { useSnackbar } from "notistack";
import React, { useState, useEffect } from "react";
import { CustomInput } from "../../components/customInput/CustomInput";
import RowButton from "../../components/RowButton";

const checkObjHasAllValue = (obj) => {
  if (Object.keys(obj).length === 0) {
    return false;
  } else {
    let val = Object.keys(obj).every((val) => {
      return obj[val] !== "" && obj[val] !== undefined;
    });
    return val;
  }
};

function ClientBankDetails({ onClickNext, onClickBack, reduxData }) {
  const [businessName, setBusinessName] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [websiteLink, setWebsiteLink] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
    border: "0px",
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginTop: 20,
    boxShadow: "none",
    border: "0px",
  };

  const businessTypeDropdown = [
    {
      label: "Select Business Type",
      value: "",
    },
    {
      label: "Private",
      value: "private",
    },
    {
      label: "Public",
      value: "public",
    },
  ];

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <CustomInput
        value={businessName}
        onChange={(data) => setBusinessName(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="Business Name "
        validator="companyName"
        type="input"
        inputStyles={{
          ...containerStyle,
          marginBottom: "10px",
        }}
      />
      <CustomInput
        value={businessType}
        onChange={(data) => setBusinessType(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="Business Type "
        validator="companyName"
        type="input"
        inputStyles={{
          ...containerStyle,
          marginBottom: "10px",
        }}
      />

      <CustomInput
        value={websiteLink}
        onChange={(data) => setWebsiteLink(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="Website Link"
        type="input"
        inputStyles={{
          ...containerStyle,
          marginBottom: "10px",
        }}
      />

      <RowButton
        onClickBack={onClickBack}
        onClickNext={() => {
          if (
            checkObjHasAllValue({
              businessName,
              businessType,
              websiteLink,
            })
          ) {
            onClickNext({
              businessName,
              businessType,
              websiteLink,
            });
          } else {
            enqueueSnackbar("Please fill all the fields", {
              variant: "error",
            });
          }
        }}
      />
    </div>
  );
}

export default ClientBankDetails;
